import React from "react";

function Header() {
  const getTitle = () => {
    const path = window.location.pathname;
    let title = "TR";
    if (path === "/automation") {
      return title;
    } else if (path === "/bilgiislem") {
      return title;
    } else if (path === "/teknisyen") {
      return title;
    } else if (path === "/tobacco") {
      return title;
    } else if (path === "/marketing") {
      return title;
    } else if (path === "/salesengineer") {
      return title;
    } else if (path === "/insankaynaklari") {
      return title;
    } else if (path === "/finansmuhasebe") {
      return title;
    } else if (path === "/kalitesurec") {
      return title;
    } else {
      title = "EN";
      return title;
    }
  };
  return (
    <div className="customFooter">
      <span>
        &copy; {1900 + new Date().getYear()}{" "}
        <a
          href={
            getTitle === "TR"
              ? "https://www.siskon.com.tr"
              : "https://www.siskon.com.tr/home"
          }
        >
          {getTitle === "TR"
            ? "Siskon Yazılım & Otomasyon"
            : "Siskon Software & Automation"}
        </a>{" "}
        v1.0.12
      </span>
    </div>
  );
}

export default Header;
